import { useCallback, useEffect } from 'react';
import {
  initKeyboardshortcuts,
  KeyboardAction,
  Module,
} from 'v2/core/utils/keyboardShortcuts';

interface HotkeyOptions {
  hotkey: string;
  onHotkey: (event?: KeyboardEvent) => void;
  isHotKeyDisabled?: boolean;
  actionTitle?: string;
  bypassFocusedElements?: boolean;
}

export function useHotkey({
  hotkey,
  onHotkey,
  isHotKeyDisabled = false,
  actionTitle = '',
  bypassFocusedElements = true,
}: HotkeyOptions) {
  const handleHotkey = useCallback(
    (event?: KeyboardEvent) => {
      if (!isHotKeyDisabled) {
        onHotkey(event);
      }
    },
    [isHotKeyDisabled, onHotkey],
  );

  useEffect(() => {
    const executeAction: KeyboardAction = {
      title: actionTitle,
      module: Module.General,
      shortcut: hotkey,
      run: handleHotkey,
      bypassFocusedElements,
    };

    const unsubscribe = initKeyboardshortcuts([executeAction]);
    return unsubscribe;
  }, [actionTitle, handleHotkey, hotkey, bypassFocusedElements]);
}
